import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { Grid, TextField, Typography, Box } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import useApi from '../../../utils/useApi';
import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import validationSchema from './validationSchema';
import UIFormContainerSave from '../../UI/Form/ContainerSave/UIFormContainer';
import UIModalOldForm from '../../UI/ModalOldForm/UIModalOldForm';
import useStorage from '../../../utils/useStorage';
import { emptyObject, isEqualObject } from '../../../utils/utils';

const initialState = {
  name: '',
  usersId: [],
};
const CashierNew = () => {
  const [open, setOpen] = useState(false);
  const [oldValues, setOldValues] = useStorage('formCashier');
  const [usersLoad, usersInfo] = useApi({
    method: 'get',
    params: { isActive: '1' },
    url: '/users',
  });

  const [registerLoad, registerInfo, setRegisterInfo] = useApi({
    method: 'post',
    url: '/cash-registers',
  });

  function changeModal() {
    setOpen(!open);
  }

  function setFormValues() {
    setOldValues(null);
    changeModal();
  }

  function updateStorage(values) {
    setOldValues(values);
  }

  useEffect(() => {
    usersLoad();
    if (oldValues && !isEqualObject(oldValues, initialState)) {
      changeModal();
    }
  }, []);

  const messageError = (error) => {
    const ops = 'Ops, alguma coisa está errada, verifique os campos';
    const apiError = registerInfo.error
      ? registerInfo.error.response.data.error
      : '';
    const messageCode = {
      1062: 'Nome de caixa existente, por favor escolha outro',
    };
    return (apiError.includes(error) && messageCode[error]) || ops;
  };

  function onSubmit(values) {
    const valuesCashier = {
      ...values,
      usersId: values.usersId.map((user) => user.id),
    };
    registerLoad({
      data: emptyObject(valuesCashier),
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={oldValues || initialState}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ setFieldValue, values, errors, touched }) => (
        <Form onBlur={() => updateStorage(values)}>
          <UIContainer container direction="row">
            <Grid item xs={12}>
              <UIFormTitle id="tour-cashier-title" title="Novo caixa" />
            </Grid>
            <Grid item xs={12}>
              <Box
                id="tour-cashier-intro"
                style={{
                  backgroundColor: '#f5f5f5',
                  borderRadius: 8,
                  padding: 16,
                  marginBottom: 16,
                }}
              >
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                  O que é um caixa?
                </Typography>
                <Typography variant="body2" style={{ marginBottom: 8 }}>
                  Um caixa é como uma "gaveta virtual" onde você registra todas as entradas e saídas de dinheiro do seu negócio.
                  Pense nele como o local onde você controla quanto entrou de vendas e quanto saiu para troco ou despesas.
                </Typography>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                  Quando devo criar um novo caixa?
                </Typography>
                <Typography variant="body2">
                  Você só precisa criar um novo caixa quando quiser ter pontos de venda/ controle separados.
                  Por exemplo: "Caixa Balcão", "Caixa Drive-Thru", "Reserva investimento" ou um caixa para cada funcionário.
                  Depois de criado, você apenas abre e fecha o mesmo caixa todos os dias — não precisa criar outro!
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                id="tour-cashier-name"
                name="name"
                label="Nome do caixa"
                error={Boolean(errors.name)}
                helperText={errors.name}
                placeholder="Informe o nome do caixa"
                fullWidth
                as={TextField}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Autocomplete
                id="tour-cashier-operators"
                multiple
                limitTags={2}
                disabled={usersInfo.loading}
                options={usersInfo.data !== null ? usersInfo.data : []}
                value={values.usersId}
                getOptionLabel={(user) => `${user.username} - ${user.name}`}
                onChange={(event, users) => setFieldValue('usersId', users)}
                noOptionsText="Sem opções"
                defaultValue={
                  oldValues !== null && oldValues.usersId
                    ? oldValues.usersId.map((value) => value)
                    : []
                }
                renderInput={(params) => (
                  <Field
                    {...params}
                    name="usersId"
                    error={Boolean(errors.usersId)}
                    helperText={touched.usersId && errors.usersId}
                    variant="standard"
                    label="Quem opera este caixa"
                    placeholder="Adicionar mais"
                    component={TextField}
                  />
                )}
              />
            </Grid>
          </UIContainer>
          <UIFormContainerSave
            id="tour-cashier-save-btn"
            container
            justify="center"
            direction="row"
            messageSucess="Caixa cadastrado com sucesso"
            messageError={messageError(1062)}
            error={registerInfo.error}
            loading={registerInfo.loading || ''}
            data={registerInfo.data}
            setrequestinfo={setRegisterInfo}
            setFormValues={() => setOldValues(null)}
          />
          <UIModalOldForm
            open={open}
            changeModal={changeModal}
            setFormValues={setFormValues}
          />
        </Form>
      )}
    </Formik>
  );
};

export default CashierNew;
